import { Box, Typography } from '@mui/material';

const FinanceXVendorDetailComponent = function (): JSX.Element {
  return (
    <Box sx={{ padding: '40px' }}>
      <Typography variant="h5" sx={{ fontWeight: 700, mb: 2 }}>
        Vendor Detail
      </Typography>
    </Box>
  );
};

export default FinanceXVendorDetailComponent;
